export default {
  menu: 'Inventory valuation',
  title: 'Inventory valuation',
  dynamicTitle: 'Inventory valuation {name}',

  table: {
    header: {
      rowNumber: 'Row',
      image: 'Photo',
      barcode: 'Barcode',
      code: 'Code',
      category: 'Category',
      name: 'Title',
      variant: 'Variable',
      openingInventory: 'First Course',
      received: 'Reached warehouse',
      minInventory: 'Minimum Inventory',
      totalInventory: 'Total inventory',
      sent: 'Posted',
      onWay: 'On the way',
      waitingToSend: 'Waiting to send',
      saleInventory: 'Inventory for sale'
    }
  }
}
